import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageWorkingHoursPerPersonDistributionRangeMapper } from '../../../../infrastructure/mappers/org-metrics/working-hours/account-average-working-hours-per-person-distribution-range.entity.mapper';
import { GetAccountAverageWorkingHoursPerPersonDistributionRequestDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-per-person-distribution.request.dto';
import { GetAccountAverageWorkingHoursPerPersonDistributionResponseDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-per-person-distribution.response.dto';
import { GetAccountAverageWorkingHoursPerPersonDistributionQuery } from '../../../queries/org-metrics/working-hours/get-account-average-working-hours-per-person-distribution.query';

export class GetAccountAverageWorkingHoursPerPersonDistributionController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageWorkingHoursPerPersonDistributionQuery,
    protected readonly mapper: AccountAverageWorkingHoursPerPersonDistributionRangeMapper
  ) {}

  async get(
    props: GetAccountAverageWorkingHoursPerPersonDistributionRequestDto
  ): Promise<GetAccountAverageWorkingHoursPerPersonDistributionResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetAccountAverageWorkingHoursPerPersonDistributionController.get encountered an error ${error}`
      );
    }
  }
}
